<template>
  <div class="projectStatesChange_div">
    <a-timeline :reverse='false'>
      <a-timeline-item v-for='(item,index) in projectStates ' :key=index :value='item'>
        <div class="project_item">
          <div class="create_time">{{moment(item.createTime).format('YYYY-MM-DD')}}</div>
          <div class="createName_div">{{item.createrName}}</div>
          <div class="stage_div">
            <template v-if="detail.dealOriginType == 1">
              <span  v-html="$t('deal.dealDetails.leaseProjectStageTypes.' + item.stage)" ></span>
            </template>
            <template v-else>
              <span  v-html="$t('deal.dealDetails.consultantProjectStageTypes.' + item.stage)" ></span>
            </template>
          </div>

        </div>
      </a-timeline-item>
    </a-timeline>
    <div v-if="projectStates.label == 0">
      <pt-empty></pt-empty>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'projectStatesChange',
  props:{
    projectStates:{
      type:Array,
      default:()=>{return []}
    },
    detail:{
      type:Object,
      default:{}
    }
  },
  methods:{
    moment,
  }
}
</script>

<style scoped lang="less">
@import "../../../core/diy";
.projectStatesChange_div{
  margin-top: 30px;
}
.dot_div{
  background: #D8D8D8;
  height: 8px;
  width: 8px;
  border-radius: 50%;
}
.project_item{
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  padding-top: 3px;
  .createName_div{
    width: 100px;
    margin-left: 20px;
  }
  .stage_div{
    background: #EDEDED;
    border-radius: 2px;
    padding: 2px 15px;
    min-width: 130px;
  }
}
</style>